// Small display formatters. Kept dumb and dependency-light.

export function fmtMbps(v: number | null | undefined): string {
  if (v == null) return '—';
  if (v >= 1000) return `${(v / 1000).toFixed(2)} Gbps`;
  return `${v.toFixed(v < 10 ? 2 : 1)} Mbps`;
}

export function fmtMs(v: number | null | undefined): string {
  return v == null ? '—' : `${v.toFixed(2)} ms`;
}

export function fmtPct(v: number | null | undefined): string {
  return v == null ? '—' : `${v.toFixed(2)}%`;
}

export function fmtDuration(secs: number | null | undefined): string {
  if (!secs) return '—';
  const s = Math.round(secs);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m < 60) return r ? `${m}m ${r}s` : `${m}m`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

export function relTime(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const s = Math.floor(diff / 1000);
  if (s < 0) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export function fmtClock(t: number): string {
  const d = new Date(t);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

// An agent is "online" if it phoned home within the last 30s.
export function isAgentOnline(lastSeen: string | null): boolean {
  if (!lastSeen) return false;
  return Date.now() - new Date(lastSeen).getTime() < 30_000;
}

export function shortId(id: string): string {
  return id.slice(0, 8);
}
